import declare from "dojo/_base/declare";
import ThreeDViewerController from "./ThreeDViewerController";
import { C8Node } from "csi/typings";

const ThreeDViewerControllerStyle = declare(ThreeDViewerController, {

	/**
	 * Add additional dependency paths for the style controller
	 */
	onDependencyPaths: function(paths) {
		paths.push("Child:StyleDefault3DViewable");
	}, 

	/** 
	 * Return the document node
	 */
	getDocument(): C8Node {
		const node = this.getNode();
		return this.m_cache.get(node.StyleDefault3DViewable);
	},
});

export = ThreeDViewerControllerStyle;

